var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.page)?_c('v-container',{staticClass:"text-center"},[_c('v-row',[_c('v-col',[_c('nuxt-content',{attrs:{"document":_vm.page}})],1)],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }